import React, { useState } from 'react';
import styled from 'styled-components';

import DashboardClassico from './Classico';
import DashboardNovo from './Novo';

// Versão do Dashboard escolhida pelo usuário, guardada no navegador. Padrão: clássica.
const VERSAO_KEY = 'dashboardVersao';
const VERSOES = [
  { id: 'classico', label: 'Clássico' },
  { id: 'novo', label: 'Novo' },
];

function carregarVersao() {
  try {
    const salva = localStorage.getItem(VERSAO_KEY);
    return VERSOES.some(({ id }) => id === salva) ? salva : 'classico';
  } catch (e) {
    return 'classico';
  }
}

function Dashboard() {
  const [versao, setVersao] = useState(carregarVersao);

  const trocarVersao = (id) => {
    setVersao(id);
    try {
      localStorage.setItem(VERSAO_KEY, id);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Faixa>
        <Seletor role="group" aria-label="Visual do Dashboard">
          <span>Visual</span>
          {VERSOES.map(({ id, label }) => (
            <button
              key={id}
              type="button"
              className={versao === id ? 'ativo' : ''}
              aria-pressed={versao === id}
              onClick={() => trocarVersao(id)}
            >
              {label}
            </button>
          ))}
        </Seletor>
      </Faixa>

      {versao === 'novo' ? <DashboardNovo /> : <DashboardClassico />}
    </>
  );
}

/* Cores fixas: o seletor aparece igual nas duas versões (a clássica desliga o tema) */

const Faixa = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 12px auto -8px;
  max-width: 90vw;
  padding: 0 15px;

  @media (min-width: 1300px) {
    max-width: 1450px;
  }
`;

const Seletor = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border: 1px solid #d6d8d3;
  border-radius: 8px;
  background-color: #fff;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 13px;

  span {
    padding: 0 8px 0 6px;
    color: #6b6e68;
  }

  button {
    border: none;
    border-radius: 6px;
    padding: 4px 12px;
    background: transparent;
    color: #333;
    cursor: pointer;
  }

  button:hover {
    background-color: #eef0ec;
  }

  button.ativo,
  button.ativo:hover {
    background-color: #1a1a1a;
    color: #fff;
  }
`;

export default Dashboard;
